import {
  Briefcase,
  Building2,
  Dumbbell,
  GraduationCap,
  HeartHandshake,
  Network,
} from 'lucide-react'
import type { Cozum } from './tipler'

/** Dernek tipine göre çözüm sayfaları. Her tipin gün içindeki gerçek işi anlatılır. */
export const COZUMLER: Cozum[] = [
  {
    slug: 'meslek-dernekleri',
    ad: 'Meslek dernekleri',
    kisa: 'Kongre, sertifika programı ve yüksek aidat disipliniyle çalışan uzmanlık dernekleri.',
    aciklama:
      'Meslek derneğinin yılı bir kongreyle ölçülür: bin kişilik kayıt, oteller, sponsorlar, bildiri süreci. Aidat yüksek ve üye bunu portaldan görmek ister. Sertifika programları ikinci gelir kalemidir.',
    ikon: Briefcase,
    ihtiyaclar: [
      {
        baslik: 'Kongre uçtan uca',
        aciklama: 'Bilet, konaklama, transfer, gala, bildiri, QR kapı ve sertifika aynı motorda.',
      },
      {
        baslik: 'Sertifika programları',
        aciklama: 'Akademi paketiyle kurs, canlı ders ve doğrulanabilir sertifika.',
      },
      {
        baslik: 'Aidat disiplini',
        aciklama:
          'Yıllık borçlandırma, hatırlatma dizisi, kartla ödeme; borcu olmayan kongreye indirimli girer.',
      },
      {
        baslik: 'Sponsor ilişkisi',
        aciklama:
          'Sponsor paketleri, stant planı, fatura bilgisi; logolar siteye ve program kitapçığına.',
      },
    ],
    gun: [
      {
        saat: '09:00',
        olay: 'Sekreter kongre kayıt raporunu açar: 612 kayıt, 340 konaklama, 12 sponsor. Otele haftalık liste gider.',
      },
      {
        saat: '11:30',
        olay: 'Bir üye portaldan aidat borcunu ödedi; kongre bileti üye fiyatına düştü, makbuz e-postasında.',
      },
      {
        saat: '14:00',
        olay: 'Bilimsel kurul bildiri değerlendirmesini tamamlar; kabul yazıları toplu gider.',
      },
      {
        saat: '17:00',
        olay: 'Sayman dönem raporunu yönetim kurulu toplantısı için PDF olarak alır.',
      },
    ],
    moduller: ['etkinlik-ve-kongre', 'aidat-ve-tahsilat', 'akademi', 'uye-portali-ve-mobil'],
  },
  {
    slug: 'federasyonlar',
    ad: 'Federasyon ve birlikler',
    kisa: 'Üye dernekleri, delegeleri ve şubeleri tek yapıda yöneten çatı kuruluşlar.',
    aciklama:
      'Federasyonun üyesi dernektir; delegeler derneklerden gelir, aidat dernek başına hesaplanır. Her dernek kendi verisini yönetir; genel merkez toplamı görür, tek tek karışmaz.',
    ikon: Network,
    ihtiyaclar: [
      {
        baslik: 'Çok kademeli yapı',
        aciklama:
          'Federasyon, üye dernek, şube. Her kademe kendi panelinde; yetki yukarıdan aşağıya.',
      },
      {
        baslik: 'Delege ve genel kurul',
        aciklama: 'Delege listesi dernek üye sayısından türer; genel kurulda oy hakkı otomatik.',
      },
      {
        baslik: 'Toplu raporlama',
        aciklama: 'Üye dernek sayısı, toplam üye, aidat tahsilat oranı bir ekranda.',
      },
      {
        baslik: 'Ortak site, ayrı kimlik',
        aciklama:
          'Federasyon sitesi üye derneklerin haberlerini toplar; her dernek kendi sitesini korur.',
      },
    ],
    gun: [
      {
        saat: '09:30',
        olay: 'Genel sekreter 47 üye derneğin aidat durumunu görür; 6 dernek gecikmiş, hatırlatma tek tıkla.',
      },
      {
        saat: '13:00',
        olay: 'Yeni üye dernek başvurusu geldi; yönetim kurulu kararıyla kabul, dernek kendi panelini aynı gün alır.',
      },
      {
        saat: '16:00',
        olay: 'Genel kurul için delege listesi üye sayılarına göre çıkarılır, derneklere onaya gönderilir.',
      },
    ],
    moduller: ['uye-yonetimi', 'kurullar-ve-genel-kurul', 'muhasebe-ve-raporlar', 'web-sitesi'],
  },
  {
    slug: 'egitim-ve-akademi-dernekleri',
    ad: 'Eğitim ve akademi dernekleri',
    kisa: 'Kurs, seminer ve sertifika üreten; geliri eğitimden gelen dernekler.',
    aciklama:
      'Bu derneklerin ürünü eğitimdir. Kurs kataloğu, canlı dersler, sınav ve sertifika; üyeye indirim, kurumsal toplu kayıt. Video arşivi büyür, kayıt ve ödeme tek yerden olmalıdır.',
    ikon: GraduationCap,
    ihtiyaclar: [
      {
        baslik: 'Kurs ve canlı ders',
        aciklama: 'Video modüller, yerleşik webinar ya da Zoom; kayıt ders arşivine düşer.',
      },
      {
        baslik: 'Sınav ve sertifika',
        aciklama: 'Geçme notu, numaralı sertifika, doğrulama adresi.',
      },
      {
        baslik: 'Kupon ve kurumsal kayıt',
        aciklama: 'Üye indirimi, kampanya kodu, şirket adına toplu kayıt ve fatura bilgisi.',
      },
      {
        baslik: 'Eğitmen ekranı',
        aciklama: 'Eğitmen yalnızca kendi kursunu ve katılımcısını görür.',
      },
    ],
    gun: [
      {
        saat: '10:00',
        olay: 'Yeni dönem programı açılır; üyelere indirimli, geçmiş katılımcılara normal fiyatla davet gider.',
      },
      { saat: '19:00', olay: 'Canlı ders başlar; 140 katılımcı. Kayıt ertesi sabah arşivde.' },
      {
        saat: '21:00',
        olay: 'Bitirme sınavını geçen 38 kişiye sertifika e-postası otomatik gider.',
      },
    ],
    moduller: ['akademi', 'aidat-ve-tahsilat', 'iletisim', 'web-sitesi'],
  },
  {
    slug: 'hemsehri-ve-yardimlasma-dernekleri',
    ad: 'Hemşehri ve yardımlaşma dernekleri',
    kisa: 'Aidat, bağış, burs ve cenaze yardımıyla dayanışma yürüten topluluk dernekleri.',
    aciklama:
      'Üye sayısı yüksek, aidat düşük, gönüllü çok. Bağış kampanyaları ve burs takibi asıl iş; yönetim çoğu zaman gönüllü ve zamanı kısıtlı. Kolay ekran ve WhatsApp bildirimi belirleyicidir.',
    ikon: HeartHandshake,
    ihtiyaclar: [
      {
        baslik: 'Kolay aidat toplama',
        aciklama: 'Kartla ya da havaleyle; WhatsApp hatırlatması; üye borcunu telefondan görür.',
      },
      {
        baslik: 'Bağış ve burs',
        aciklama: 'Kampanya hedefi, bağışçı makbuzu, bursiyer dosyası ve ödeme planı.',
      },
      { baslik: 'Gönüllü takibi', aciklama: 'Etkinlik günü görev listesi; kim nerede.' },
      {
        baslik: 'Basit site',
        aciklama: 'Haber, duyuru, yönetim kurulu, bağış sayfası; kurulum bir öğleden sonra.',
      },
    ],
    gun: [
      {
        saat: '08:30',
        olay: 'Başkan telefondan bakar: gece 14 üye aidat ödemiş, kampanya yüzde 72’de.',
      },
      { saat: '12:00', olay: 'Burs komisyonu 20 öğrenciyi onaylar; aylık ödeme planı kurulur.' },
      {
        saat: '20:00',
        olay: 'Pilav günü için gönüllü listesi WhatsApp’tan gider; 31 kişi görev aldı.',
      },
    ],
    moduller: ['bagis-ve-kampanya', 'aidat-ve-tahsilat', 'iletisim', 'uye-portali-ve-mobil'],
  },
  {
    slug: 'spor-kulupleri',
    ad: 'Spor kulüpleri',
    kisa: 'Sporcu, lisans, antrenman grubu ve turnuva yöneten dernek statülü kulüpler.',
    aciklama:
      'Kulüpte üye, sporcu ve veli üç ayrı kişidir. Aylık aidat, branş ve grup bazlı tarife, turnuva kaydı ve tesis kullanımı takip edilir. Kart ve QR ile giriş tesiste günlük iştir.',
    ikon: Dumbbell,
    ihtiyaclar: [
      {
        baslik: 'Branş ve grup',
        aciklama: 'Sporcu branşı, yaş grubu ve antrenman saati özel alanlarla; tarife gruba göre.',
      },
      {
        baslik: 'Veli hesabı',
        aciklama: 'Veli portaldan çocuğunun aidatını öder, duyuruyu görür.',
      },
      { baslik: 'Turnuva ve kamp', aciklama: 'Etkinlik paketiyle kayıt, konaklama ve transfer.' },
      {
        baslik: 'Tesis girişi',
        aciklama: 'Dijital üye kartı QR ile tesis girişi; borcu olan uyarı alır.',
      },
    ],
    gun: [
      {
        saat: '07:00',
        olay: 'Sabah antrenmanı: 24 sporcu QR ile giriş yaptı, ikisinin aidatı gecikmiş; veliye bildirim gitti.',
      },
      { saat: '15:00', olay: 'Yaz kampı kaydı açılır; 60 kontenjan iki günde dolar.' },
      { saat: '18:00', olay: 'Sayman ay sonu tahsilat oranını grup bazında görür.' },
    ],
    moduller: ['uye-yonetimi', 'aidat-ve-tahsilat', 'etkinlik-ve-kongre', 'uye-portali-ve-mobil'],
  },
  {
    slug: 'vakiflar',
    ad: 'Vakıflar',
    kisa: 'Bağış, burs, mütevelli heyeti ve düzenli raporlamayla çalışan vakıflar.',
    aciklama:
      'Vakfın üyesi yoktur, mütevellisi ve bağışçısı vardır. Düzenli bağış, burs fonu, proje bazlı harcama ve denetime hazır kayıt öndedir. Aidat modülü kullanılmaz; bağış ve muhasebe kullanılır.',
    ikon: Building2,
    ihtiyaclar: [
      {
        baslik: 'Mütevelli ve kurullar',
        aciklama: 'Mütevelli heyeti, yönetim kurulu, toplantı ve karar kaydı.',
      },
      { baslik: 'Düzenli bağış', aciklama: 'Aylık talimat, bağışçı makbuzu, yıl sonu dökümü.' },
      {
        baslik: 'Proje ve fon takibi',
        aciklama: 'Fon bazlı gelir-gider; hangi bağış hangi projeye harcandı.',
      },
      {
        baslik: 'Denetim hazırlığı',
        aciklama: 'Kalemden belgeye bağlantı; denetim kurulu salt okunur erişim.',
      },
    ],
    gun: [
      {
        saat: '09:00',
        olay: 'Aylık düzenli bağışlar gece tahsil edildi; 218 bağışçı, 3 kart reddi görevliye düştü.',
      },
      { saat: '11:00', olay: 'Burs fonundan 40 öğrenciye ödeme yapılır; her ödeme fon kaleminde.' },
      { saat: '15:00', olay: 'Mütevelli heyeti toplantısı: kararlar numaralı, tutanak PDF.' },
    ],
    moduller: [
      'bagis-ve-kampanya',
      'muhasebe-ve-raporlar',
      'kurullar-ve-genel-kurul',
      'guvenlik-ve-kvkk',
    ],
  },
]

export const COZUM_HARITASI = new Map(COZUMLER.map((c) => [c.slug, c]))
